import { Injectable } from '@angular/core';
import {
  FormArray,
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';

import {
  DataPropConfig,
  getValidations,
  InputType,
  isCompareInput,
  isRangeInput,
} from 'dg-input-lib';
import { ToastrService } from 'ngx-toastr';

import { MatDialog } from '@angular/material/dialog';
import { CreateDraftComponent } from '../../create-draft/create-draft.component';
import { AppGenServiceService } from './app-gen-service.service';
import { MessageDisplayService } from 'src/app/digigov/services/message-display/message-display.service';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from 'src/app/digigov/services/authentication.service';
import { I } from '@angular/cdk/keycodes';
import { Subject, BehaviorSubject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { Validation } from 'dg-error-lib';

interface ComboModel {
  id?: string | number;
  optionText: string;
  optionValue: string | number;
  optionDesc?: string;
  isRange?: boolean;
  optionDisabled?: boolean;
  optionIcon?: string;
}
interface InputDataModel {
  inputId: string | number;
  inputType: string | number;
  inputName?: string;
  inputPlaceholder?: string;
  inputMandatory?: boolean;
  inputOptions?: ComboModel[];
  inputValue?: unknown;
  validations?: Validation[];
}

@Injectable({
  providedIn: null,
})
export class CommonService {
  dataTableRowData: any;
  additionalVOListWithoutKeyValue: any;
  devForm;
  commonComponents;
  notifyParentCommonServiceSubject: Subject<any>;
  comboMapValues: any = {};
  nextTab: boolean;
  parentCommonService: CommonService = null;
  developerFormData: any;
  fieldId: any;
  countValue = 1;
  compareData = {};
  countValue2: number = 1;

  qcaFlagDatabyApi: any = false;
  qcaPassFlagDatabyApi: any = false;
  refId: any;

  //nextTab: boolean;
  constructor(
    private router: Router,
    private appGenServiceService: AppGenServiceService,
    private toastr: ToastrService,
    private msgDsplyService: MessageDisplayService,
    private dialog: MatDialog,
    private http: HttpClient,
    private authService: AuthenticationService,
    public datePipe: DatePipe
  ) {
    this.notifyParentCommonServiceSubject = new Subject();
    this.displayDevForm = new Subject();
  }

  inputDataPropConfig: DataPropConfig = {
    idProp: 'fieldId',
    typeProp: 'fieldType',
    nameProp: 'label',
    placeholderProp: 'placeholder',
    requiredProp: 'isMandatory',
    comboProp: 'comboMapValues',
    validationsProp: 'validations',
  };
  isDataTableHideShow = {};
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  formGroup;
  cmnFormId;
  tId;
  fileId;
  appGenFormGroup: FormGroup;
  private appGentransData: any;
  private appGentransFormData: any;
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  FORMID: any;
  tid: any;
  appId: any;
  resultObj: any;
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  resultValue: any;
  auditComponentListId: any;
  inputJsonData: any;
  cases: any;
  isReadOnly: any;
  eventId: any;
  inputCaseViewdata: any;
  caseVO: any;
  dataForPost: any;
  menuFetchData: any;
  trangactionResponse: any = {};
  additionalVOList: any;

  onLoadEvent = false;
  parentEventData: any;
  data: any;
  displayDevForm: Subject<any>;
  isCaseForm: boolean = true;
  saveFormFromDialog = new BehaviorSubject<boolean>(false);
  /*  callGenerateDraft(exe: any, form: any, transactionId: any) {
    throw new Error('Method not implemented.');
  } */

  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  getTransData() {
    return this.appGentransData;
  }

  setAppGenTransData(data) {
    this.appGentransData = data;
  }
  getTransFormData() {
    return this.appGentransFormData;
  }

  setAppGenTransFormData(data) {
    this.appGentransFormData = { ...data, ...this.appGentransFormData };
  }
  getDraftData(formId, tid, exe, appId) {
    this.appGenServiceService
      .saveData(this.appGenServiceService.getAppGenData(formId, tid))
      .subscribe((res: any) => {
        console.log('savedata =', res);

        if (res.data?.resultValue?.transactionId) {
          this.tid = res.data?.resultValue?.transactionId;
          this.callGenerateDraft(
            exe,

            res.data.resultValue.transactionId,
            appId
          );
        } else {
          this.msgDsplyService.errorToast({
            errors: [
              {
                message: 'your trangaction id is not generated',
              },
            ],
          });
        }
      });
  }

  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  callGenerateDraft(data, trangactionId, appId) {
    let optionVal =
      data.ruleSubNotiId != undefined
        ? data.ruleSubNotiId
        : data.notificationTmpltId;
    let placeHolderMap = {};
    let devFormData = JSON.parse(localStorage.getItem('developerFormData'));
    let entityAttributeJson = this.getEntityAttributeMapData(
      this.resultObj,
      this.appGenServiceService.getAppGenData(this.cmnFormId, this.tid),
      true,
      true,
      devFormData,
      false,
      true,
      'dd MMMM yyyy'
    );

    let addtionalAttribute = this.additionalVOListWithoutKeyValue;
    let currentDate = new Date();

    placeHolderMap = {
      ...entityAttributeJson,
      ...addtionalAttribute,
      ...{ currentDate: currentDate },
    };
    const dialogRef1 = this.dialog.open(CreateDraftComponent, {
      // appRefid check form
      width: '80vw',

      data: {
        draftId: data.draftId, //dynamic

        placeHolderMap: placeHolderMap,

        plmap: entityAttributeJson,

        isPalceHolder: true,

        refId: this.inputCaseViewdata?.docId,

        tmpltId: optionVal,

        appId: this.appId,

        draftTitle: 'Temporary Letter',

        from: 'prepare',

        templateId: {
          optionValue: data.draftId + '~' + optionVal + '~' + optionVal,

          optionText: data.tmpltName,
        }, //dynamic

        case: {
          docId: trangactionId,

          appTypeId: this.appId,

          jobId: -1,

          subjectId: -1,
        },

        subjectId: this.inputCaseViewdata?.subjectId,

        licenceNumber: this.inputCaseViewdata?.additionalAttribute4,

        custRefNum: this.inputCaseViewdata?.additionalAttribute2,

        applicationRefId: this.inputCaseViewdata?.additionalAttribute3,

        jobId: '-1',

        reqType: this.inputCaseViewdata?.additionalAttribute4,

        reqTrnId: this.inputCaseViewdata?.additionalAttribute4,

        badgeNumber: '123',

        brailleFlag: 'Yes',

        deliveryClass: 'deliveryClass',

        reqNo: this.inputCaseViewdata?.docNo,

        appRefNo: this.inputCaseViewdata?.additionalAttribute3,

        docTypeId: this.inputCaseViewdata?.appTypeId,
      },
    });
    dialogRef1.afterClosed().subscribe((result) => {
      // this.initializeFormGroup(this.resultObj);
    });
  }

  notification(data) {
    console.log('Notification');
  }
  requestValue: BehaviorSubject<boolean> = new BehaviorSubject(false);
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  initializeLoadEvent(jsonObject) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component].hasOwnProperty('cmnFormFieldEventList')) {
          let list = jsonObject[component]['cmnFormFieldEventList'].map(
            (event, key) => {
              if (event.eventName.toLowerCase() == 'onload') {
                return jsonObject[component]['cmnFormFieldEventList'][key]
                  .cmnEventExecutionList[0].implementingMethod;
              }
            }
          );
          list?.forEach((item) => {
            if (item) {
              let parameters =
                item?.trim()?.match(/\(.*\)/g) != null
                  ? item?.match(/\(.*\)/g)[0]
                  : '()';
              let methodName = item?.replace(parameters, '');
              this.callUserdefindFunction(methodName + parameters);
            }
          });
        }
      }
      if (Array.isArray(jsonObject[component]?.children)) {
        this.initializeLoadEvent(jsonObject[component]?.children);
      }
    });
    return jsonObject;
  }

  // Custom Function Common Function

  async callUserdefindFunction(funtionName, fieldObj?) {
    const a = await import(
      'src/app/app-gen-client/custom-function/custom-functions.service'
    );
    const dynamicService = new a['CustomFunctionsService'](
      this.appGenFormGroup,
      this.resultObj,
      this.inputCaseViewdata,
      this.parentEventData,
      this.cases,
      this.caseVO,
      this.dataForPost,
      this.menuFetchData,
      this.http,
      this.dialog,
      this.dataTableRowData,
      this.authService,
      this.additionalVOList,
      this.appGenServiceService,
      fieldObj,
      this.toastr,
      this.requestValue,
      this.datePipe,
      this
    );

    eval('dynamicService.' + funtionName);
  }
  async eventCall(name: string, form?: FormGroup, data?: any) {
    console.log('event data = ', name, form, data);
    if (name) {
      const a = await import('../service/test1.service');

      const dynamicService = new a['Test1Service'](form, data);
      name.split(';').forEach((ele) => {
        if (ele) {
          // dynamicService.validateTextInput();
          eval('dynamicService.' + ele);
        }
        // eval("this.appGenServiceService." + ele);
      });
    }
  }

  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  // refId
  initializeFormId(FORMID, tid, appId, resultObj) {
    this.FORMID = FORMID;
    this.tid = tid;
    this.appId = appId;
    this.resultObj = resultObj;
    this.nextTab = false;
  }

  //this.refId = refId;

  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  // Date Validation Common Function

  dateValue: any;

  dateValidation(
    valiID,
    CompIdFirst,
    CompIdSecond,
    data,
    formgroupInitilized,
    beforeChange?
  ) {
    this.dateValue = null;
    let currentDate = new Date();

    if (valiID == '5') {
      // Allow future Date
      this.dateValue = {
        from: new Date(currentDate.setDate(currentDate.getDate() + 1)),
      };

      // this.setValidation(this.dateValue, data);
    } else if (valiID == '6') {
      // Allow today and future
      this.dateValue = { from: new Date(currentDate) };
    } else if (valiID == '7') {
      // Allow past Date
      this.dateValue = {
        to: new Date(currentDate.setDate(currentDate.getDate() - 1)),
      };
    } else if (valiID == '8') {
      // Allow today and past

      this.dateValue = { to: new Date(currentDate) };
    } else if (valiID == '9') {
      // Allow date greater than <<X>> date
      if (formgroupInitilized) {
        let compValue;
        if (
          data?.attribute?.validations[0]?.val == null ||
          data?.attribute?.validations[0]?.val == undefined
        ) {
          compValue = this.appGenFormGroup.controls[CompIdFirst].value;
        } else {
          compValue = data.attribute.validations[0].val;
        }

        if (compValue != null) {
          if (beforeChange) {
            this.dateValue = { from: new Date(compValue) };
          } else {
            this.dateValue = { to: new Date(compValue) };
          }

          let validationsObj = [
            {
              async: false,
              errorMessage: 'date 2 should be greater than date 1.',
              id: 2,
              cmpFormId: CompIdSecond,
              type: 'date',
              value: this.dateValue,
            },
          ];
          //this.appGenFormGroup.controls[CompIdFirst].clearValidators();

          this.validateDate(this.resultObj, CompIdSecond, validationsObj);
        }
      }
    } else if (valiID == '10') {
      // Allow greater than and equal to <<X>> date
      if (formgroupInitilized) {
        let compValue;
        if (data.attribute.validations[0].val == null) {
          compValue = this.appGenFormGroup.controls[CompIdFirst].value;
        } else {
          compValue = data.attribute.validations[0].val;
        }

        if (compValue != null) {
          let givenDate = new Date(compValue);

          if (beforeChange) {
            this.dateValue = {
              from: new Date(givenDate.setDate(givenDate.getDate() - 1)),
            };
          } else {
            this.dateValue = {
              to: new Date(givenDate.setDate(givenDate.getDate() - 1)),
            };
          }

          let validationsObj = [
            {
              async: false,
              errorMessage: 'date 2 should be greater than date 1.',
              id: 2,
              cmpFormId: CompIdSecond,
              type: 'date',
              value: this.dateValue,
            },
          ];
          //this.appGenFormGroup.controls[CompIdFirst].clearValidators();

          this.validateDate(this.resultObj, CompIdSecond, validationsObj);
        }
      }
    } else if (valiID == '11') {
      // Allow Past date less than to <<X>> date

      if (formgroupInitilized) {
        let compValue;
        if (
          data?.attribute?.validations[0]?.val == null ||
          data?.attribute?.validations[0]?.val == undefined
        ) {
          compValue = this.appGenFormGroup.controls[CompIdFirst].value;
        } else {
          compValue = data.attribute.validations[0].val;
        }

        if (compValue != null) {
          let givenDate = new Date(compValue);
          if (beforeChange) {
            this.dateValue = {
              to: new Date(givenDate.setDate(givenDate.getDate() - 1)),
            };
          } else {
            this.dateValue = {
              from: new Date(givenDate.setDate(givenDate.getDate() + 1)),
            };
          }
          let validationsObj = [
            {
              async: false,
              errorMessage: 'date 2 should be less than date 1.',
              id: 2,
              type: 'date',
              cmpFormId: CompIdSecond,
              value: this.dateValue,
            },
          ];
          //this.appGenFormGroup.controls[CompIdFirst].clearValidators();

          this.validateDate(this.resultObj, CompIdSecond, validationsObj);
        }
      }
    } else if (valiID == '12') {
      //Allow Past date less than and equal to <<X>> date

      if (formgroupInitilized) {
        let compValue;
        if (data.attribute.validations[0].val == null) {
          compValue = this.appGenFormGroup.controls[CompIdFirst].value;
        } else {
          compValue = data.attribute.validations[0].val;
        }

        if (compValue != null) {
          if (beforeChange) {
            this.dateValue = { to: new Date(compValue) };
          } else {
            this.dateValue = { from: new Date(compValue) };
          }

          let validationsObj = [
            {
              async: false,
              errorMessage: 'date 2 should be greater than date 1.',
              id: 2,
              type: 'date',
              cmpFormId: CompIdSecond,
              value: this.dateValue,
            },
          ];
          //this.appGenFormGroup.controls[CompIdFirst].clearValidators();

          this.validateDate(this.resultObj, CompIdSecond, validationsObj);
        }
      }
    }
  }

  // initialize FormGroup Common Function

  initializeFormGroup(formData, enableDisable?): void {
    if (!formData) return;
    const group = {};
    let validators = [];
    let asyncValidators = [];

    formData.forEach((data) => {
      if (
        data.fieldType == 93 ||
        data.fieldType == 94 ||
        data.fieldType == 101 ||
        data.fieldType == 89 ||
        data.fieldType == 102 ||
        data.fieldType == 97 ||
        data.fieldType == 106 ||
        data.fieldType == 107
      ) {
        // If Container Hide Validation Not add by enableDisable

        enableDisable = enableDisable ? true : data?.attribute?.hideShow;
        this.initializeFormGroup(data?.children, enableDisable);
      }
      if (
        data.fieldType != 102 &&
        data.fieldType != 93 &&
        data.fieldType != 94 &&
        data.fieldType != 89 &&
        data.fieldType != 97 &&
        data.fieldType != 101 &&
        data.fieldType != 106 &&
        data.fieldType != 107
      ) {
        if (data?.fieldType == 0) {
          if (
            data?.attribute?.validations != null &&
            data?.attribute?.validations.length != 0
          ) {
            data?.attribute?.validations?.forEach((comp) => {
              this.dateValidation(comp.validationId, null, null, null, false);
            });

            let arr = this.dateValue
              ? [
                  {
                    type: 'date',
                    async: false,
                    id: 1234,
                    value: this.dateValue,
                    errorMessage: 'Please enter date in correct format.',
                  },
                ]
              : [];

            // console.log('date', arr);

            data.attribute.validations = [
              ...data.attribute.validations,
              ...arr,
            ];
            this.dateValue = null;
          } else {
            data.attribute.validations = [];
          }
        }
        // Remove dote from input label
        if (
          data?.fieldType == 0 ||
          data?.fieldType == 1 ||
          data?.fieldType == 3 ||
          data?.fieldType == 4 ||
          data?.fieldType == 10 ||
          data?.fieldType == 44
        ) {
          let lengthOfString = data.attribute.label.length;
          if (lengthOfString > 70) {
            // console.log("length",lengthOfString);
            data.attribute.className =
              data.attribute.className + ' remove-dote appgen-w-35';
          }
        }

        if (data?.fieldType == 10) {
          data.attribute.validations = [
            ...data.attribute.validations,
            ...[
              {
                async: false,
                errorMessage: 'Please enter a valid email id',
                type: 'email',
                value: null,
                id: 0,
              },
              {
                id: 6,
                async: false,
                type: 'pattern',
                value: '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$',
                errorMessage: 'Please enter a valid email id',
              },
            ],
          ];
        }

        if (data?.fieldType == 2) {
          data.attribute.placeholder = {
            from: data.attribute.startDatePlaceHolder,
            to: data.attribute.endDatePlaceHolder,
          };

          if (
            data?.attribute?.isMandatory &&
            data?.attribute?.hideShow == false &&
            !enableDisable
          ) {
            data.attribute.validations = [
              ...data.attribute.validations,
              ...[
                {
                  async: false,
                  errorMessage: 'Date Range is required',
                  type: 'complex',
                  value: {
                    from: [
                      {
                        id: 0,
                        async: false,
                        type: 'required',
                        value: null,
                        errorMessage: 'Please enter a valid Date Range',
                      },
                    ],
                    to: [
                      {
                        id: 0,
                        async: false,
                        type: 'required',
                        value: null,
                        errorMessage: 'Please enter a valid Date Range',
                      },
                    ],
                  },
                  id: 0,
                },
              ],
            ];
          }
        }
        if (data?.fieldType == 79) {
          /*  if (data?.attribute?.hideShow == false && !enableDisable
          ) {
           
          } */
        }

        if (
          data?.attribute?.isMandatory &&
          data?.attribute?.hideShow == false &&
          !enableDisable
        ) {
          data.attribute.validations = [
            ...data.attribute.validations,
            ...[
              {
                async: false,
                errorMessage: data?.attribute?.label + ` is required.`,
                type: 'required',
                value: null,
                id: 0,
              },
            ],
          ];
        }
        if (data?.attribute?.maxLength) {
          data.attribute.validations = [
            ...data.attribute.validations,
            ...[
              {
                id: 0,
                async: false,
                type: 'maxLength',
                value: data?.attribute?.maxLength,
                errorMessage:
                  'Max Length should be ' +
                  parseInt(data?.attribute?.maxLength),
              },
            ],
          ];
        }
        if (data?.attribute?.minLength) {
          data.attribute.validations = [
            ...data.attribute.validations,
            ...[
              {
                id: 0,
                async: false,
                type: 'minLength',
                value: data?.attribute?.minLength,
                errorMessage:
                  'Min Length should be ' +
                  parseInt(data?.attribute?.minLength),
              },
            ],
          ];
        }

        if (data?.attribute?.max) {
          data.attribute.validations = [
            ...data.attribute.validations,
            ...[
              {
                id: 0,
                async: false,
                type: 'numberMaxLengthCustom',
                value: (numInput: FormControl) => {
                  if (
                    numInput?.value?.toString()?.length > data?.attribute?.max
                  ) {
                    return {
                      numberMaxLengthCustom: true,
                    };
                  }
                  return null;
                },
                errorMessage:
                  'Max no. of Digit should be ' +
                  parseInt(data?.attribute?.max),
              },
            ],
          ];
        }
        if (data?.attribute?.min) {
          data.attribute.validations = [
            ...data.attribute.validations,
            ...[
              {
                id: 0,
                async: false,
                type: 'numberMinLengthCustom',
                value: (numInput: FormControl) => {
                  if (
                    numInput?.value?.toString()?.length < data?.attribute?.min
                  ) {
                    return {
                      numberMinLengthCustom: true,
                    };
                  }
                  return null;
                },
                errorMessage:
                  'Minimum no. of Digit should be ' +
                  parseInt(data?.attribute?.min),
              },
            ],
          ];
        }

        if (!this.isCaseForm) {
          data.attribute.enableDisable = true;
        }

        if (data?.attribute?.validations && !enableDisable) {
          data?.attribute?.validations.forEach((validation) => {
            if (validation?.async)
              asyncValidators = [
                ...asyncValidators,
                getValidations(validation, this.getType(data)),
              ];
            else
              validators = [
                ...validators,
                getValidations(validation, this.getType(data)),
              ];
          });
        }
        // validators.push(Validators.required);
        if (this.getType(data)?.toString()) {
          if (isCompareInput(this.getType(data)))
            group[this.getId(data)] = new FormGroup({
              operator: new FormControl(null, validators?.[0]?.operator),
              from: new FormControl(null, validators?.[0]?.from),
              to: new FormControl(null, validators?.[0]?.to),
            });
          else if (isRangeInput(this.getType(data)))
            group[this.getId(data)] = new FormGroup({
              from: new FormControl(null, validators?.[0]?.from),
              to: new FormControl(null, validators?.[0]?.to),
            });
          else if (this.getType(data.attribute) === InputType.CHECKBOX) {
            if (data?.attribute?.comboMap) {
              this.appGenServiceService
                .getComboIds(data?.attribute?.comboMap.toString())
                .subscribe((response: any) => {
                  data.attribute.comboMapValues = response;

                  if (this.eventId == 23) {
                    let defalutValue = data?.defaultValue
                      ? data.defaultValue
                      : data.tempDefaultValue;
                    if (defalutValue) {
                      let defaultObj = defalutValue.split(',');
                      // ['353553','54465575']
                      data.defaultValue = [];
                      // data.attribute.comboMapValues.forEach((v, i) => {
                      //   if (defaultObj[i] === 'true') {
                      //     data.defaultValue.push(v);
                      //   }
                      // });
                      let checkboxListObj = {};
                      defaultObj.forEach((element) => {
                        checkboxListObj = data.attribute.comboMapValues.find(
                          (x) => x.optionValue == element
                        );
                        data.defaultValue.push(checkboxListObj);
                      });
                    }
                  }
                  const checkboxArray = [];
                  this.getOptions(data.attribute)?.forEach(() => {
                    checkboxArray.push(new FormControl(null));
                  });

                  group[this.getId(data.attribute).toString()] = new FormArray(
                    checkboxArray,
                    validators ? validators : [],
                    asyncValidators
                  );
                  this.appGenFormGroup.addControl(
                    this.getId(data.attribute).toString(),
                    group[this.getId(data.attribute)]
                  );
                });
            }
          } else {
            let defaultValue = null;
            if (this.eventId == 23) {
              defaultValue = data?.defaultValue ? data?.defaultValue : null;
            } else {
              defaultValue = data?.attribute?.defaultValue
                ? data?.attribute?.defaultValue
                : null;
            }
            if (data?.fieldType == 0 && defaultValue) {
              this.appGenServiceService.setAppGenData(
                data.fieldId,
                defaultValue
              );
              if (this.parentCommonService) {
                let formObj = {
                  ...this.appGenServiceService.getAppGenData(
                    this.FORMID,
                    this.tid
                  ),
                };
                this.getKeys(formObj).forEach((index) => {
                  if (this.componentMap[index] == 0 && formObj[index]) {
                    formObj[index] = this.datePipe.transform(
                      new Date(formObj[index]),
                      'dd/MM/yyyy'
                    );
                  }
                });
                // let formObjOfDevForm = { ...formObj };
                // this.getKeys(formObjOfDevForm).forEach((index) => {
                //   if (
                //     this.componentMap[index] == 0 &&
                //     formObjOfDevForm[index]
                //   ) {
                //     formObjOfDevForm[index] = this.datePipe.transform(
                //       new Date(formObjOfDevForm[index]),
                //       'dd MMMM yyyy'
                //     );
                //   }
                // });
                this.parentCommonService?.notifyParentCommonServiceSubject?.next(
                  {
                    data: formObj,
                    fieldId: this.fieldId,
                    resultObj: this.inputJsonData,
                  }
                );
                this.displayDevForm.next({ fieldId: this.fieldId });
              }
            }

            if (data?.fieldType == 3 && this.isComponentId(defaultValue)) {
              let value = null;
              value = this.extractValue(this.additionalVOList, defaultValue);
              //value Oper
              if (value) {
                if (this.eventId == 23) {
                  data.defaultValue = value;
                } else {
                  data.attribute.defaultValue = value;
                }
                defaultValue = value;
              }
            }

            group[this.getId(data)] = new FormControl(
              defaultValue,
              validators?.[0] ? validators : [],
              asyncValidators
            );
          }
        }
        validators = [];
        asyncValidators = [];
      }
      this.appGenServiceService.setAppGenData(
        data.fieldId,
        this.eventId == 23 ? data.defaultValue : data.attribute.defaultValue
      );

      // this.callVisibilityRule(data, this.appGenFormGroup);
    });
    this.beforeChange(this.appGenServiceService.appGenData);
    if (group && Object.keys(group).length !== 0)
      this.formGroup = { ...this.formGroup, ...group };
    if (this.formGroup != null) {
      this.appGenFormGroup = new FormGroup(this.formGroup);
      this.appGenFormGroup.updateValueAndValidity();
    }
  }

  setAppGenDataForAudit(fieldId, data, colData?) {
    if (fieldId == null) {
      this.appGenServiceService.appGenData = {
        ...this.appGenServiceService.appGenData,
        ...data,
      };
    } else {
      if (colData) {
        data.forEach((ele) => {
          for (const x in ele) {
            if (
              x != 'uniqueKey' &&
              x != '_dynamicRowIndex' &&
              x != 'operation' &&
              x != 'actions'
            ) {
              colData.forEach((element) => {
                if (element.columnId == x) {
                  ele[element.fieldId] = ele[x];
                }
              });
            }
          }
        });
      }

      this.appGenServiceService.appGenData[fieldId] = data;
      setTimeout(() => {
        this.beforeChange(this.appGenServiceService.appGenData);
      }, 1500);
    }
  }

  compareData2;
  isComponentId(str) {
    if (str && typeof str === 'string' && str.includes('ComponentId')) {
      return true;
    }
    return false;
  }
  extractValue(AdditionalAttributeList, data) {
    let stringObj = data;
    let returnValue = null;
    if (stringObj.includes('ComponentId')) {
      const parentId = stringObj.split('_')[1].trim();
      if (AdditionalAttributeList != null) {
        AdditionalAttributeList?.forEach((AttributeObject) => {
          for (const key in AttributeObject) {
            if (AttributeObject.hasOwnProperty(key)) {
              let keyObj = null;
              let valueObj = null;
              if (key == 'key') {
                keyObj = AttributeObject[key];
                if (parentId == keyObj) {
                  returnValue = AttributeObject['value'];
                  return returnValue;
                }
              }
            }
          }
        });
      }
    }
    return returnValue;
  }
  addValidators(data, dependCompId) {
    this.appGenFormGroup?.controls[dependCompId].clearValidators();

    let asyncValidators = [];
    let validators = [];
    let validationDefaultObj = {
      async: false,
      errorMessage: data?.attribute?.label + ` is required.`,
      type: 'required',
      value: null,
      id: 0,
    };

    if (
      (data.fieldType == 44 ||
        data.fieldType == 3 ||
        data.fieldType == 0 ||
        data.fieldType == 79) &&
      Array.isArray(data?.attribute?.validations) &&
      data?.attribute?.validations.length >= 1
    ) {
      data?.attribute?.validations.push(validationDefaultObj);
    }
    data?.attribute?.validations?.forEach((validation) => {
      if (validation?.async)
        asyncValidators = [
          ...asyncValidators,
          getValidations(validation, this.getType(data)),
        ];
      else
        validators = [
          ...validators,
          getValidations(validation, this.getType(data)),
        ];
    });

    let validation =
      validators && Array.isArray(validators) && validators.length != 0
        ? validators
        : [Validators.required];
    this.appGenFormGroup?.controls[dependCompId].setValidators(validation);
    if (
      asyncValidators &&
      Array.isArray(asyncValidators) &&
      asyncValidators.length != 0
    ) {
      this.appGenFormGroup?.controls[dependCompId].setAsyncValidators(
        asyncValidators
      );
    }
    this.appGenFormGroup?.controls[dependCompId].updateValueAndValidity();
  }

  removeAndaddValidation(jsonObject, enableDisable) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component]?.fieldId != null) {
          if (enableDisable) {
            if (
              !jsonObject[component]?.attribute?.hideShow &&
              jsonObject[component]?.attribute?.isMandatory
            ) {
              if (
                this.appGenFormGroup?.controls[jsonObject[component]?.fieldId]
              ) {
                this.appGenFormGroup?.controls[
                  jsonObject[component]?.fieldId
                ].clearValidators();
                this.appGenFormGroup?.controls[
                  jsonObject[component]?.fieldId
                ].updateValueAndValidity();
              }
            }
          } else {
            if (
              !jsonObject[component]?.attribute?.hideShow &&
              jsonObject[component]?.attribute?.isMandatory
            ) {
              if (
                this.appGenFormGroup?.controls[jsonObject[component]?.fieldId]
              ) {
                this.addValidators(
                  jsonObject[component],
                  jsonObject[component].fieldId
                );
              }
            }
          }
        }
      }

      if (Array.isArray(jsonObject[component]?.children)) {
        enableDisable = enableDisable ? true : false;
        this.removeAndaddValidation(
          jsonObject[component]?.children,
          enableDisable
        );
      }
    });
    return jsonObject;
  }

  callShowMessage(messageId) {}
  callNotification(notificationId) {
    let entityAttributeJson = this.getEntityAttributeMapData(
      this.resultObj,
      this.appGenServiceService.getAppGenData(this.FORMID, this.tid)
    );
    let notificationJson = {
      CustomerUserId: this.inputCaseViewdata,
      EventCode: notificationId,
      placeHolderMap: entityAttributeJson,
    };
    this.appGenServiceService
      .requestNotification(notificationJson)
      .subscribe((res: any) => {
        if (res.data == 'true') {
          console.log('Notification is sent successfully');
        } else {
          console.log('Notification is not sent successfully');
        }
      });
    /// write code for notification
  }
  callFn() {
    console.log('Ashish------->');
  }
  createEventObj(
    fieldId,
    dependCmpFormId,
    actionType,
    valueObj,
    fieldType?,
    successOrFailure?
  ) {
    successOrFailure = 1;
    let opValue = null;
    if (this.appGenFormGroup?.controls[fieldId]) {
      opValue = this.appGenFormGroup?.controls[fieldId]?.value?.optionValue;
    }

    let eventObj = {
      fieldId: fieldId,
      attribute: {
        fieldType: fieldType,
      },
      cmnFormFieldEventList: [
        {
          eventId: 202,
          eventName: 'onChange',
          cmpFormId: fieldId,
          cmnEventExecutionList: [
            {
              executionType: 533306,
              eventId: 202,
              cmnVisibilityRulesList: [
                {
                  operator: '==',
                  value: opValue ? opValue : 6900,
                  cmnVisibilityRuleOutputList: [],
                },
              ],
            },
          ],
        },
      ],
    };
    switch (actionType) {
      case 'SetValue':
        let setValue = {
          isSuccess: successOrFailure,
          dependCmpFormId: dependCmpFormId,
          action: actionType,
          opValue: valueObj,
        };

        eventObj.cmnFormFieldEventList[0].cmnEventExecutionList[0].cmnVisibilityRulesList[0].cmnVisibilityRuleOutputList[0] = setValue;
        break;
      case 'SetFocus':
        let setfocus = {
          isSuccess: successOrFailure,
          dependCmpFormId: dependCmpFormId,
          action: actionType,
          opValue: valueObj,
        };
        eventObj.cmnFormFieldEventList[0].cmnEventExecutionList[0].cmnVisibilityRulesList[0].cmnVisibilityRuleOutputList[0] = setfocus;
        break;
      case 'Load Combo':
        let loadCombo = {
          isSuccess: successOrFailure,
          dependCmpFormId: dependCmpFormId,
          action: actionType,
          opValue: valueObj,
        };

        eventObj.cmnFormFieldEventList[0].cmnEventExecutionList[0].cmnVisibilityRulesList[0].cmnVisibilityRuleOutputList[0] = loadCombo;
        break;
      case 'Hide':
        let hideValue = {
          isSuccess: successOrFailure,
          dependCmpFormId: dependCmpFormId,
          action: actionType,
        };

        eventObj.cmnFormFieldEventList[0].cmnEventExecutionList[0].cmnVisibilityRulesList[0].cmnVisibilityRuleOutputList[0] = hideValue;
        break;
      case 'Show':
        let showValue = {
          isSuccess: successOrFailure,
          dependCmpFormId: dependCmpFormId,
          action: actionType,
        };

        eventObj.cmnFormFieldEventList[0].cmnEventExecutionList[0].cmnVisibilityRulesList[0].cmnVisibilityRuleOutputList[0] = showValue;
        break;
      case 'Enabled':
        let enableValue = {
          isSuccess: successOrFailure,
          dependCmpFormId: dependCmpFormId,
          action: actionType,
        };

        eventObj.cmnFormFieldEventList[0].cmnEventExecutionList[0].cmnVisibilityRulesList[0].cmnVisibilityRuleOutputList[0] = enableValue;
        break;
      case 'Disabled':
        let disabledValue = {
          isSuccess: successOrFailure,
          dependCmpFormId: dependCmpFormId,
          action: actionType,
        };

        eventObj.cmnFormFieldEventList[0].cmnEventExecutionList[0].cmnVisibilityRulesList[0].cmnVisibilityRuleOutputList[0] = disabledValue;
        break;
      case 'Mandatory':
        let mandatory = {
          isSuccess: successOrFailure,
          dependCmpFormId: dependCmpFormId,
          action: actionType,
        };

        eventObj.cmnFormFieldEventList[0].cmnEventExecutionList[0].cmnVisibilityRulesList[0].cmnVisibilityRuleOutputList[0] = mandatory;
        break;

      case 'Optional':
        let optionalValue = {
          isSuccess: successOrFailure,
          dependCmpFormId: dependCmpFormId,
          action: actionType,
        };

        eventObj.cmnFormFieldEventList[0].cmnEventExecutionList[0].cmnVisibilityRulesList[0].cmnVisibilityRuleOutputList[0] = optionalValue;
        break;
      case 'Generate Letter with Edit':
        let generateLetterWithEdit = {
          isSuccess: successOrFailure,
          dependCmpFormId: dependCmpFormId,
          action: actionType,
          tmpltName: valueObj[2].replace(/("|')/g, ''),
          notificationTmpltId: valueObj[0].replace(/("|')/g, ''),
          draftId: valueObj[1].replace(/("|')/g, ''),
        };
        eventObj.cmnFormFieldEventList[0].cmnEventExecutionList[0].cmnVisibilityRulesList[0].cmnVisibilityRuleOutputList[0] = generateLetterWithEdit;
        break;
      case 'Call TS Funtion':
        let callTSFuntionEdit = {
          isSuccess: successOrFailure,
          dependCmpFormId: dependCmpFormId,
          action: actionType,
          functionName: valueObj[0].replace(/("|')/g, ''),
        };

        eventObj.cmnFormFieldEventList[0].cmnEventExecutionList[0].cmnVisibilityRulesList[0].cmnVisibilityRuleOutputList[0] = callTSFuntionEdit;
        break;
      case 'Notification':
        let notification = {
          isSuccess: successOrFailure,
          dependCmpFormId: dependCmpFormId,
          action: actionType,
          notificationTmpltId: valueObj[0].replace(/("|')/g, ''),
        };
        eventObj.cmnFormFieldEventList[0].cmnEventExecutionList[0].cmnVisibilityRulesList[0].cmnVisibilityRuleOutputList[0] = notification;
        break;
      case 'ShowMessage':
        let showMessage = {
          isSuccess: successOrFailure,
          dependCmpFormId: dependCmpFormId,
          action: actionType,
          notificationTmpltId: valueObj[0].replace(/("|')/g, ''),
        };
        eventObj.cmnFormFieldEventList[0].cmnEventExecutionList[0].cmnVisibilityRulesList[0].cmnVisibilityRuleOutputList[0] = showMessage;
        break;
      default:
        console.log('Invalid case');
        break;
    }
    return eventObj;
  }
  getKeys(map: any) {
    if (map) return Object.keys(map);
  }
  entityAttributeJson: any = {};

  // fieldidToValueObj:any;
  // firstTimeLoadData(formObj){
  //   console.log('firstTimeload', formObj)
  //   this.beforeChange(formObj)
  // }

  getEntityAttributeMapData(
    jsonObject: any,
    formObj: any,
    comboText?,
    removeEntityName?,
    developerFormData?,
    isComboObj?,
    isEntityAttributeValue?,
    dateFormat?
  ) {
    this.entityAttributeJson = {};
    this.getEntityAttributeMap(
      jsonObject,
      formObj,
      comboText,
      removeEntityName,
      developerFormData,
      isComboObj,
      isEntityAttributeValue,
      null,
      dateFormat
    );

    return this.entityAttributeJson;
  }

  // Validation for Calender Common Function

  validateDate(jsonObject: any, dependCompId: any, validationobj: any) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component]?.fieldId == dependCompId) {
          if (
            jsonObject[component]?.attribute?.validations != null &&
            jsonObject[component]?.attribute?.validations.length != 0
          ) {
            let tempValidationPastDate =
              jsonObject[component]?.attribute?.validations;
            tempValidationPastDate.forEach((ob) => {
              if (ob.id == 1234 && ob.id != undefined) {
                let toDate = ob.value.to,
                  fromDate = validationobj[0].value.from;

                validationobj[0].value = { from: fromDate, to: toDate };
              }
            });
          }

          jsonObject[component].attribute = {
            ...jsonObject[component].attribute,
          };

          jsonObject[component].attribute.validations = validationobj;

          return jsonObject[component];
        }
      }

      if (Array.isArray(jsonObject[component]?.children)) {
        this.validateDate(
          jsonObject[component]?.children,
          dependCompId,
          validationobj
        );
      }
    });
    return jsonObject;
  }
  // Entity Attribute Map Common Function for Template / Advance Rule
  getEntityAttributeMap(
    jsonObject: any,
    formObj: any,
    comboText?,
    removeEntityName?,
    developerFormData?,
    isComboObj?,
    isEntityAttributeValue?,
    isDataTable?,
    dateFormat?
  ) {
    this.getKeys(jsonObject)?.forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (
          jsonObject[component]?.parentEntityName &&
          jsonObject[component]?.attributeName
        ) {
          let key = null;
          if (
            jsonObject[component]?.fieldType == 90 &&
            !jsonObject[component]?.attributeName.startsWith('cke_')
          ) {
            jsonObject[component].attributeName =
              'cke_' + jsonObject[component]?.attributeName;
            console.log('cke', component);
          }
          if (removeEntityName) {
            key = jsonObject[component].attributeName.trim();
          } else {
            key =
              jsonObject[component].parentEntityName.trim() +
              '.' +
              jsonObject[component].attributeName.trim();
          }
          let objValue = '';

          this.getKeys(formObj).forEach((index) => {
            if (index == jsonObject[component]?.fieldId) {
              if (
                jsonObject[component]?.fieldType == 18 ||
                jsonObject[component]?.fieldType == 98 ||
                jsonObject[component]?.fieldType == 71 ||
                jsonObject[component]?.fieldType == 81 ||
                jsonObject[component]?.fieldType == 5
              ) {
                if (comboText) {
                  objValue =
                    formObj[index]?.optionText != undefined
                      ? formObj[index]?.optionText.trim()
                      : '';
                  if (!objValue && formObj[index]) {
                    objValue = formObj[index];
                  }
                } else {
                  objValue =
                    formObj[index]?.optionValue != undefined
                      ? formObj[index]?.optionValue
                      : '';
                  if (!objValue && formObj[index]) {
                    objValue = formObj[index];
                  }
                }
                if (isComboObj) {
                  objValue = formObj[index];
                }
              } else {
                if (this.componentMap[index] == 0 && formObj[index]) {
                  if (dateFormat && jsonObject[component]?.fieldType == 0) {
                    objValue = this.datePipe.transform(
                      new Date(formObj[index]),
                      dateFormat
                    );
                  } else {
                    objValue = this.datePipe.transform(
                      new Date(formObj[index]),
                      'dd-MM-yyyy'
                    );
                  }
                } else {
                  objValue = formObj[index];
                }
              }
            }
          });
          if (isEntityAttributeValue) {
            let keyObj = {};
            keyObj[jsonObject[component].attributeName] = objValue;
            if (jsonObject[component].attributeName) {
              if (
                this.entityAttributeJson[
                  jsonObject[component]?.parentEntityName
                ]
              ) {
                let obj = this.entityAttributeJson[
                  jsonObject[component]?.parentEntityName
                ];
                if (jsonObject[component].attributeName) {
                  obj[jsonObject[component].attributeName] = objValue;
                }
              } else {
                this.entityAttributeJson[
                  jsonObject[component]?.parentEntityName
                ] = keyObj;
              }
              if (isDataTable) {
                this.entityAttributeJson[
                  jsonObject[component]?.parentEntityName
                ] = isDataTable;
              }
            }
          } else {
            this.entityAttributeJson[key] = objValue;
          }
        }
        if (jsonObject[component]?.fieldType == 108) {
          if (developerFormData) {
            let dataForDevForm =
              developerFormData?.[jsonObject?.[component]?.fieldId]?.data;
            if (dataForDevForm) {
              Object.keys(dataForDevForm)?.forEach((res) => {
                console.log(res);
                if (typeof dataForDevForm[res] == 'string') {
                  let arr = dataForDevForm[res]?.split('/');
                  if (arr?.length == 3) {
                    let year = arr[2];
                    let month = arr[1];
                    let day = arr[0];
                    if (
                      year <= 9999 &&
                      year >= 1000 &&
                      month >= 1 &&
                      month <= 12 &&
                      day >= 1 &&
                      day <= 31
                    ) {
                      let date = new Date(year, month - 1, day);
                      dataForDevForm[res] = this.datePipe.transform(
                        date,
                        'dd MMMM yyyy'
                      );
                    }
                  }
                }
              });
            }
            this.getEntityAttributeMap(
              developerFormData?.[jsonObject?.[component]?.fieldId]?.resultObj,
              developerFormData?.[jsonObject?.[component]?.fieldId]?.data,
              comboText,
              removeEntityName,
              developerFormData,
              isComboObj,
              isEntityAttributeValue,
              null,
              dateFormat
            );
          }
        }
        if (jsonObject[component]?.fieldType == 12) {
          this.getEntityAttributeMap(
            jsonObject[component],
            formObj,
            comboText,
            removeEntityName,
            developerFormData,
            isComboObj,
            isEntityAttributeValue,
            this.appGenServiceService?.[jsonObject[component]?.fieldId],
            dateFormat
          );
        }
      }
      if (Array.isArray(jsonObject[component])) {
        this.getEntityAttributeMap(
          jsonObject[component],
          formObj,
          comboText,
          removeEntityName,
          developerFormData,
          isComboObj,
          isEntityAttributeValue,
          null,
          dateFormat
        );
      }
      if (Array.isArray(jsonObject[component]?.children)) {
        this.getEntityAttributeMap(
          jsonObject[component]?.children,
          formObj,
          comboText,
          removeEntityName,
          developerFormData,
          isComboObj,
          isEntityAttributeValue,
          null,
          dateFormat
        );
      }
    });
    return jsonObject;
  }

  componentMap: any = {};
  isMandatoryComponentMap: any = {};
  isLabelName = {};

  // Combo Map Common Function
  compMap(jsonObject, enableDisable, formComponentId?) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component]?.fieldId != null) {
          this.componentMap[jsonObject[component]?.fieldId] =
            jsonObject[component]?.fieldType;
          if (enableDisable && !formComponentId) {
            jsonObject[component].attribute.enableDisable = enableDisable;
          }
          if (
            formComponentId &&
            jsonObject[component]?.fieldId == formComponentId
          ) {
            jsonObject[component].attribute.enableDisable = enableDisable;
            jsonObject[component].attribute = {
              ...jsonObject[component].attribute,
            };
            return;
          }
        }
        if (jsonObject[component]?.attribute?.isMandatory) {
          this.isMandatoryComponentMap[jsonObject[component]?.fieldId] = true;
        } else {
          this.isMandatoryComponentMap[jsonObject[component]?.fieldId] = false;
        }
        if (jsonObject[component]?.fieldType == 12) {
          if (
            jsonObject[component]?.attribute?.validations &&
            jsonObject[component]?.attribute?.validations[0]?.errorMessage ==
              'Add atleast single row'
          ) {
            this.isMandatoryComponentMap[jsonObject[component]?.fieldId] = true;
            this.isDataTableFindHyperLink(
              jsonObject[component]?.children,
              jsonObject[component]?.fieldId
            );
          } else {
            this.isMandatoryComponentMap[
              jsonObject[component]?.fieldId
            ] = false;
          }
        }
        this.isLabelName[jsonObject[component]?.fieldId] =
          jsonObject[component]?.lbl;
      }

      if (Array.isArray(jsonObject[component])) {
        this.compMap(jsonObject[component], enableDisable, formComponentId);
      }
      if (Array.isArray(jsonObject[component]?.children)) {
        this.compMap(
          jsonObject[component]?.children,
          enableDisable,
          formComponentId
        );
      }
    });
    return jsonObject;
  }
  isHyperLinkMadatory = {};

  // Datatable Take Hyper Link Map Common Function
  isDataTableFindHyperLink(jsonObject, fieldId) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component]?.fieldType == 23) {
          this.isHyperLinkMadatory[fieldId] = Number(
            jsonObject[component]?.attribute?.dependentCmpntId
          );
        }
      }

      if (Array.isArray(jsonObject[component])) {
        this.isDataTableFindHyperLink(jsonObject[component], fieldId);
      }
      if (Array.isArray(jsonObject[component]?.children)) {
        this.isDataTableFindHyperLink(jsonObject[component]?.children, fieldId);
      }
    });
    return jsonObject;
  }

  //Empty string Common Function

  isEmptyStr(str) {
    if (str != undefined && str != '') {
      let temp = str;

      if (temp && typeof temp == 'string') {
        temp = temp.trim();
        return temp.length > 0;
      } else if (temp && typeof temp == 'number') {
        return true;
      } else if (temp && typeof temp == 'boolean') {
        return true;
      } else if (temp && typeof temp == 'object') {
        return true;
      }
      return false;
    } else {
      return false;
    }
  }

  // checkAudit() {
  //   let testData = [];
  //   this.inputJsonData.forEach((element) => {
  //     if (element.fieldType == 107) {
  //       element.children.forEach((child) => {
  //         testData.push({
  //           fieldId: child.attribute.fieldId,
  //           isAuditable: child.attribute.isAuditable,
  //         });
  //       });
  //     } else {
  //       testData.push({
  //         fieldId: element.attribute.fieldId,
  //         isAuditable: element.attribute.isAuditable,
  //       });
  //     }
  //   });
  //   return testData;
  // }
  hideShow: boolean;
  isElementHideShow(jsonObject, fieldId) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component]?.fieldId == fieldId) {
          this.hideShow = jsonObject[component]?.attribute?.hideShow;
        }
      }

      if (Array.isArray(jsonObject[component])) {
        this.isElementHideShow(jsonObject[component], fieldId);
      }
      if (Array.isArray(jsonObject[component]?.children)) {
        this.isElementHideShow(jsonObject[component]?.children, fieldId);
      }
    });
    return this.hideShow;
  }
  cmptType: any;
  isComponentType(jsonObject, fieldId) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component]?.fieldId == fieldId) {
          this.cmptType = jsonObject[component]?.attribute?.fieldType;
        }
      }

      if (Array.isArray(jsonObject[component])) {
        this.isComponentType(jsonObject[component], fieldId);
      }
      if (Array.isArray(jsonObject[component]?.children)) {
        this.isComponentType(jsonObject[component]?.children, fieldId);
      }
    });
    return this.cmptType;
  }
  displayOrder: boolean;
  compDisplayOrder(jsonObject, fieldId) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component]?.fieldId == fieldId) {
          this.displayOrder = jsonObject[component]?.attribute?.displayOrder;
        }
      }

      if (Array.isArray(jsonObject[component])) {
        this.compDisplayOrder(jsonObject[component], fieldId);
      }
      if (Array.isArray(jsonObject[component]?.children)) {
        this.compDisplayOrder(jsonObject[component]?.children, fieldId);
      }
    });
    return this.displayOrder;
  }

  auditData: boolean;
  //  Common Function for data
  getComponentData(jsonObject, fieldId) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component]?.fieldId == fieldId) {
          this.auditData = jsonObject[component]?.attribute?.isAuditable;
        }
      }

      if (Array.isArray(jsonObject[component])) {
        this.getComponentData(jsonObject[component], fieldId);
      }
      if (Array.isArray(jsonObject[component]?.children)) {
        this.getComponentData(jsonObject[component]?.children, fieldId);
      }
    });
    return this.auditData;
  }

  storeParentId: any = null;
  parentId: any = null;
  getParentIdforTab(formDetails, fieldId) {
    formDetails.forEach((component) => {
      if (!Array.isArray(component)) {
        if (component?.fieldId == fieldId) {
          this.parentId = this.storeParentId;
        }
      }

      if (Array.isArray(component)) {
        this.getParentIdforTab(component, fieldId);
      }
      if (
        Array.isArray(component?.children) &&
        component?.children.length > 0
      ) {
        if (component?.fieldType == 102 || component?.fieldType == 94) {
          this.storeParentId = component?.fieldId;
        }
        this.getParentIdforTab(component?.children, fieldId);
      }
    });
    return this.parentId;
  }

  checkBoxData: any;
  getCheckboxId(jsonObject, fieldId) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (jsonObject[component]?.fieldId == fieldId) {
          this.checkBoxData = jsonObject[component]?.attribute?.comboMapValues;
        }
      }

      if (Array.isArray(jsonObject[component])) {
        this.getCheckboxId(jsonObject[component], fieldId);
      }
      if (Array.isArray(jsonObject[component]?.children)) {
        this.getCheckboxId(jsonObject[component]?.children, fieldId);
      }
    });
    return this.checkBoxData;
  }

  beforeChange(data) {
    Object.keys(data).forEach((key, index) => {
      let auditData;
      let hideShow;
      let parentHideShow;
      let parentId;
      let valueOrder;
      let comptId;
      let compType;
      if (data[key] != undefined) {
        auditData = this.getComponentData(this.resultObj, key);
        hideShow = this.isElementHideShow(this.resultObj, key);
        parentId = this.getParentIdforTab(this.resultObj, key);
        parentHideShow = this.isElementHideShow(this.resultObj, parentId);
        valueOrder = this.compDisplayOrder(this.resultObj, key);
        comptId = key;
        compType = this.isComponentType(this.resultObj, key);
      }
      this.storeParentId = null;
      this.parentId = null;
      let obj = {
        value: data[key],
        isModified: true,
        isAuditable: auditData,
        isHideShow: parentHideShow ? true : hideShow,
        parentId,
        valueOrder,
        comptId,
        compType,
      };
      // let obj = { value: data[key], isModified: false };
      if (!isNaN(parseInt(key))) {
        // if (data[key] != undefined)
        this.compareData[key] = obj;
      } else {
        this.compareData[key] = obj.value;
      }
    });
    this.compareData2 = JSON.stringify(this.compareData);
  }

  FormAudit(valueFromDraftData?) {
    console.log(this.resultValue);
    // this.resultValue.push({isFormFirstTimeLoad:true})
    // let testData = this.checkAudit();
    let compareData = JSON.parse(this.compareData2);
    let formObj = this.appGenServiceService.getAppGenData(
      this.FORMID,
      this.tid
    );
    let finalData = {};
    Object.keys(formObj).forEach((key, index) => {
      let auditData;
      let hideShow;
      let parentHideShow;
      let parentId;
      let valueOrder;
      let comptId;
      let compType;
      if (formObj[key] != undefined) {
        auditData = this.getComponentData(this.resultObj, key);
        hideShow = this.isElementHideShow(this.resultObj, key);
        parentId = this.getParentIdforTab(this.resultObj, key);
        parentHideShow = this.isElementHideShow(this.resultObj, parentId);
        valueOrder = this.compDisplayOrder(this.resultObj, key);
        comptId = key;
        compType = this.isComponentType(this.resultObj, key);
      }

      let obj = {
        value: formObj[key],
        isModified: false,
        isAuditable: auditData,
        isHideShow: parentHideShow ? true : hideShow,
        parentId,
        valueOrder,
        comptId,
        compType,
      };
      // let obj = { value: formObj[key], isModified: true };
      if (!isNaN(parseInt(key))) {
        if (formObj[key] != undefined) {
          finalData[key] = obj;
        }
      } else {
        finalData[key] = obj.value;
      }
    });
    if (this.countValue == 0 && formObj.transactionId == undefined) {
      //this.compareData = finalData;
      this.countValue = this.countValue + 1;
      compareData = finalData;
    } else {
      if (formObj.transactionId && this.countValue == 1) {
        // this.compareData = this.FORMID;
        compareData = {
          ...compareData,
          formId: this.FORMID,
          transactionId: this.tid,
        };
        this.countValue = this.countValue + 1;
      }
      Object.keys(finalData).forEach((key) => {
        if (!isNaN(parseInt(key))) {
          // if (finalData[key].compType == 90) {
          //   finalData[key].isAuditable = false;
          //   finalData[key].value = btoa(
          //     unescape(encodeURIComponent(finalData[key].value))
          //   );
          // }
          if (finalData[key].isAuditable && !finalData[key].isHideShow) {
            // DATATABLE & MULTISELECT
            if (
              finalData[key]?.value?.length > 0 &&
              Array.isArray(finalData[key].value)
            ) {
              if (finalData[key]?.value[0].hasOwnProperty('uniqueKey')) {
                // DATATABLE
                if (!Array.isArray(compareData[key]?.value)) {
                  finalData = this.compareFunc(
                    finalData[key]?.value,
                    compareData[key] ? compareData[key].value : undefined,
                    key,
                    finalData
                  );
                } else {
                  finalData = this.compareFunc(
                    finalData[key]?.value,
                    compareData[key] ? compareData[key].value : undefined,
                    key,
                    finalData
                  );
                }
              } else {
                // MULTISELECT
                if (!Array.isArray(compareData[key]?.value)) {
                  let finalDataString = '';
                  finalData[key]?.value.forEach((element) => {
                    if (!finalDataString) {
                      finalDataString = String(
                        element.optionValue ? element.optionValue : element
                      );
                    } else {
                      finalDataString =
                        finalDataString +
                        ',' +
                        String(
                          element.optionValue ? element.optionValue : element
                        );
                    }
                  });

                  finalData = this.compareFunc(
                    finalDataString,
                    compareData[key]
                      ? compareData[key]?.value == 'null'
                        ? (compareData[key].value = '')
                        : compareData[key]?.value
                      : undefined,
                    key,
                    finalData
                  );
                } else {
                  finalData = this.compareFunc(
                    finalData[key]?.value,
                    compareData[key] ? compareData[key].value : undefined,
                    key,
                    finalData
                  );
                }
              }

              // COMBO & RADIO BUTTONS
            } else if (finalData[key]?.value?.optionValue != null) {
              if (compareData[key]?.value?.optionValue == undefined) {
                finalData = this.compareFunc(
                  finalData[key]?.value?.optionValue,
                  compareData[key]?.value,
                  key,
                  finalData
                );
              } else {
                finalData = this.compareFunc(
                  finalData[key]?.value,
                  compareData[key]?.value,
                  key,
                  finalData
                );
              }
              // EVERYTHING ELSE
            } else {
              finalData = this.compareFunc(
                finalData[key]?.value,
                compareData[key]?.value,
                key,
                finalData
              );
            }
          } else {
            // ckEditor if isAuditable : false
            if (finalData[key].compType == 90) {
              finalData[key].isAuditable = false;
              finalData[key].value = btoa(
                unescape(encodeURIComponent(finalData[key].value))
              );
            } else if (finalData[key].compType == 19) {
              // CheckBox if isAuditable : false
              let checkboxData = this.getCheckboxId(this.resultObj, key);
              let checkboxFinalDataForFinalData = [];
              if (Array.isArray(finalData[key].value)) {
                let splitCheckBoxArrayForFinalData = Array.isArray(
                  finalData[key].value
                )
                  ? finalData[key].value
                  : finalData[key].value.split(',');

                splitCheckBoxArrayForFinalData.forEach((element, i) => {
                  if (element == true || element == 'true') {
                    checkboxFinalDataForFinalData.push(checkboxData[i]);
                  }
                });
              } else {
                checkboxFinalDataForFinalData = checkboxData;
              }
              finalData[key].oldValue = '';
              finalData[key].value = finalData[key].value
                ? checkboxFinalDataForFinalData
                : '';
              finalData[key].isAuditable = false;
            }
            if (!isNaN(parseInt(key))) {
              finalData[key].isModified = false;
              finalData[key].oldValue = '';
            }
          }
        }
      });
      /* After Save Api
      console.log('final data', finalData);
      this.compareData = finalData; */
    }
    // IF CASE DOESN'T REFRESH AND ISFORMFIRSTTIMELOAD SET TO FALSE
    this.resultValue.isFormFirstTimeLoad = valueFromDraftData
      ? false
      : this.resultValue.isFormFirstTimeLoad;
    this.appGenFormGroup.markAsPristine();
    return finalData;
  }
  compareFunc(finalDataValue, compareDataValue, key, finalData) {
    //console.log('key', key);
    finalData[key].oldValue = '';
    if (this.auditComponentListId?.find((e) => e == key)) {
      // FOR ADD TO AUDIT EVENT TYPE
      finalData[key].isModified = true;
    } else {
      if (JSON.stringify(finalDataValue) === JSON.stringify(compareDataValue)) {
        if (finalData[key].compType == 19) {
          let splitCheckBoxArray = Array.isArray(compareDataValue)
            ? compareDataValue
            : compareDataValue.split(',');
          finalData[key].oldValue = compareDataValue ? splitCheckBoxArray : '';
        } else {
          finalData[key].oldValue = compareDataValue ? compareDataValue : '';
        }
        finalData[key].oldValue = '';
        //  console.log('equal');
        if (!isNaN(parseInt(key))) {
          if (
            finalData[key].isAuditable &&
            this.resultValue.isFormFirstTimeLoad
          ) {
            finalData[key].isModified = true;
          } else {
            finalData[key].isModified = false;
            if (finalData[key].compType == 90) {
              finalData[key].value = btoa(
                unescape(encodeURIComponent(finalDataValue))
              );
              finalData[key].oldValue = '';
            }
          }
          // FOR CKEDITOR ; audit was still apperaring due to isformfirsttimeload
          if (finalData[key].compType == 90) {
            finalData[key].isModified = false;
          }
        }
      } else {
        //  console.log('not equal');
        //FOR CHECK BOX FIELD TYPE
        if (finalData[key].compType == 19) {
          let checkboxData = this.getCheckboxId(this.resultObj, key);
          // FOR COMPAREDATA
          let splitCheckBoxArray = Array.isArray(compareDataValue)
            ? compareDataValue
            : compareDataValue.split(',');
          let checkboxFinalData = [];
          if (splitCheckBoxArray && typeof splitCheckBoxArray[0] == 'object') {
            checkboxFinalData = splitCheckBoxArray;
          } else {
            splitCheckBoxArray.forEach((element) => {
              let findData = checkboxData.find((x) => x.optionValue == element);
              checkboxFinalData.push(findData);
            });
          }
          // FOR FINALDATA
          let splitCheckBoxArrayForFinalData = Array.isArray(finalDataValue)
            ? finalDataValue
            : finalDataValue.split(',');
          let checkboxFinalDataForFinalData = [];
          splitCheckBoxArrayForFinalData.forEach((element, i) => {
            if (element == true || element == 'true') {
              checkboxFinalDataForFinalData.push(checkboxData[i]);
            }
          });
          finalData[key].oldValue = compareDataValue ? checkboxFinalData : '';
          finalData[key].value = finalDataValue
            ? checkboxFinalDataForFinalData
            : '';
        } else if (finalData[key].compType == 90) {
          //finalData[key].oldValue = compareDataValue ? btoa(unescape(encodeURIComponent(compareDataValue))) : '';
          finalData[key].value = btoa(
            unescape(encodeURIComponent(finalData[key].value))
          );
          finalData[key].oldValue = '';
        } else {
          finalData[key].oldValue = compareDataValue ? compareDataValue : '';
        }
        if (Array.isArray(finalData[key].value)) {
          finalData[key].isModified = true;
        } else {
          finalData[key].isModified = true;
        }
      }
    }
    return finalData;
  }

  filterObj = [];
  getComponent(jsonObject, filterByValue) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        let filterData = filterByValue.forEach((item) => {
          if (item == jsonObject[component].lbl) {
            this.filterObj.push(jsonObject[component].fieldId);
          }
        });
      }

      if (Array.isArray(jsonObject[component])) {
        this.getComponent(jsonObject[component], filterByValue);
      }
      if (Array.isArray(jsonObject[component]?.children)) {
        this.getComponent(jsonObject[component]?.children, filterByValue);
      }
    });
    return this.filterObj;
  }

  getArrayFromObject(obj: { [key: string]: any }): any[] {
    return Object?.keys(obj)?.map((key) => obj?.[key]);
  }

  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  // type 2 Combo

  findcomboStringObj(jsonObject, data?) {
    this.getKeys(jsonObject).forEach((component) => {
      if (!Array.isArray(jsonObject[component])) {
        if (
          jsonObject[component]?.fieldId != null &&
          jsonObject[component]?.attribute?.comboConfigurationString &&
          JSON.stringify(
            jsonObject[component]?.attribute?.comboConfigurationString
          ) != '{}'
        ) {
          this.comboStringMethod(jsonObject[component], data);
        }
      }

      if (Array.isArray(jsonObject[component]?.children)) {
        this.findcomboStringObj(jsonObject[component]?.children, data);
      }
    });
    return jsonObject;
  }
  comboStringMethod(element, data) {
    let parentId = null;
    let childIdKey = null;
    let parentIdKey = null;
    let parentIdR = null;
    let childIdR = null;
    if (
      element?.attribute?.comboConfigurationString &&
      JSON.stringify(element?.attribute?.comboConfigurationString) != '{}'
    ) {
      let tempComboConfigurationString = Object.assign(
        {},
        element?.attribute?.comboConfigurationString
      );
      let comboString = {};
      let comboMap = element?.attribute?.comboMap;
      for (let key in tempComboConfigurationString) {
        let tempString: string = tempComboConfigurationString[key];
        tempString = Number(tempString) ? tempString.toString() : tempString;
        if (tempString.includes('ComponentId')) {
          parentId = tempComboConfigurationString[key].split('_')[1];

          childIdKey = element?.attribute?.fieldId;
          parentIdKey = key;
        } else {
          comboString[key] = tempString;
        }

        if (data?.attribute.fieldId.toString() == parentId) {
          parentIdR = data?.attribute.fieldId.toString();
          childIdR = element?.attribute?.fieldId;
          let fieldType = this.componentMap[parentId];
          let objValue = null;
          if (fieldType == 5) {
            objValue = this.appGenFormGroup.controls[parentId]?.value
              ?.optionValue;
          } else {
            objValue = this.appGenFormGroup.controls[parentId]?.value;
          }
          comboString[parentIdKey] = objValue
            ? objValue
            : this.appGenFormGroup.controls[parentId]?.value;
        }
      }

      if (JSON.stringify(comboString) != '{}') {
        let flag = true;
        Object.keys(comboString).forEach((key) => {
          if (comboString[key]) {
            typeof Number(comboString[key]) == 'number'
              ? (comboString[key] = Number(comboString[key]))
              : comboString[key];
          } else {
            flag = false;
          }
        });
        if (flag) {
          this.appGenServiceService
            .setDropDown(comboMap, comboString)
            .subscribe(
              (res: any) => {
                element.attribute.comboMapValues = res.data;
                return;
              },
              (err) => {
                console.error(err);
              }
            );
        }
      } else if (JSON.stringify(comboString) != '{}') {
        element.attribute.comboMapValues = [];
      }
    }
  }

  doInit = true;

  hashRestrict(event) {
    // FOR HASH KEY RESTRICT
    var charCode;
    charCode = event.charCode;
    if (charCode === 35) {
      this.doInit = false;
      return false;
    } else {
      this.doInit = true;
      return true;
    }
  }

  roleBasedView(comp, isView: boolean) {
    // FOR ATTACHMENT COMP
    if (comp.fieldType == '25') {
      isView && (comp.attribute.allowFileToAttach = false);
      isView && (comp.attribute.allowDelete = false);
    }
    // FOR DATATABLE
    if (comp.fieldType == '12') {
      isView && (comp.attribute.canAddRow = false);
      isView && (comp.attribute.showDelete = false);
      isView && (comp.attribute.canEditInline = false);
      isView && (comp.attribute.isEditable = false);
    }
  }

  checkSubmitResponse: any;
  saveExecution(exe?) {
    if (this.appGenFormGroup.valid || exe?.json?.saveAsDraft) {
      let formObj = {
        ...this.appGenServiceService.getAppGenData(this.FORMID, this.tid),
      };
      let formValid = false;
      let dialogMessage = false;
      let labelName;
      this.getKeys(formObj).forEach((index) => {
        let formObjData = formObj[index];
        this.isDataTableHideShow = this.isElementHideShow(
          this.resultObj,
          index
        );
        if (
          this.componentMap[index] == 12 &&
          this.isMandatoryComponentMap[index] &&
          !this.isDataTableHideShow
        ) {
          let count = 0;
          if (formObjData) {
            let flag = true;
            this.getKeys(formObjData).forEach((index1) => {
              if (formObjData[index1].operation == 'delete') {
                count = count + 1;
              }

              let formRowObj = formObjData[index1];
              if (
                this.isHyperLinkMadatory[index] &&
                flag &&
                this.isMandatoryComponentMap[this.isHyperLinkMadatory[index]] &&
                !formRowObj[this.isHyperLinkMadatory[index]]
              ) {
                dialogMessage = true;
                labelName = this.isLabelName[index];
                formValid = true;
                flag = false;
                this.msgDsplyService.errorToast({
                  errors: [
                    {
                      message:
                        'Please fill dialog data for datatable row ' +
                        labelName,
                    },
                  ],
                });
              }
            });

            if (formObjData.length == count) {
              formValid = true;
              labelName = this.isLabelName[index];
            }
          }
          if (!formObjData) {
            formValid = true;
            labelName = this.isLabelName[index];
          }
        }
      });
      if (!formValid) {
        let finalObjectData = this.FormAudit();
        finalObjectData = {
          ...finalObjectData,
          executionType: exe?.executionType,
        };
        // refId: this.refId,
        if (!finalObjectData.hasOwnProperty('transactionId')) {
          Object.keys(finalObjectData).forEach((ele) => {
            if (!!Number(ele)) {
              finalObjectData[ele].isAuditable = false;
              finalObjectData[ele].isModified = false;
            }
          });
        }

        this.appGenServiceService.saveData(finalObjectData).subscribe(
          (res1: any) => {
            console.log('savedata =', res1);
            this.checkSubmitResponse = res1?.data?.resultValue;
            this.tid = res1?.data?.resultValue?.transactionId;
            for (const key in this.checkSubmitResponse) {
              if (
                Object.prototype.hasOwnProperty.call(
                  this.checkSubmitResponse,
                  key
                )
              ) {
                const element = this.checkSubmitResponse[key];
                if (!isNaN(Number(key))) {
                  // this.notifySaveComponentResponse.next(key);
                }
              }
            }

            if (!exe?.successMessage) {
              exe.successMessage = 'Form Saved Succesfully';
            }
            // Final data for Audit set into CompareData
            this.resultValue.isFormFirstTimeLoad = false;
            this.compareData2 = JSON.stringify(finalObjectData);

            this.msgDsplyService.successToast({
              messages: [exe?.successMessage, ''],
            });
            this.setAppGenTransData(res1?.data?.resultValue?.transactionId);
            let entityAttributeJson = this.getEntityAttributeMapData(
              this.resultObj,
              this.appGenServiceService.getAppGenData(this.FORMID, this.tid),
              false,
              true
            );
            this.setAppGenTransFormData(entityAttributeJson);

            //
            if (this.parentCommonService) {
              let formObj = {
                ...this.appGenServiceService.getAppGenData(
                  this.FORMID,
                  this.tid
                ),
              };
              this.getKeys(formObj).forEach((index) => {
                if (this.componentMap[index] == 0 && formObj[index]) {
                  formObj[index] = this.datePipe.transform(
                    new Date(formObj[index]),
                    'dd/MM/yyyy'
                  );
                }
              });
              this.parentCommonService?.notifyParentCommonServiceSubject?.next({
                data: formObj,
                fieldId: this.fieldId,
                resultObj: this.inputJsonData,
              });
            }
          },
          (err: any) => {
            console.error('Error in saveApi', err);
            if (!exe?.errorMessage) {
              exe.errorMessage = 'Oops! Something went wrong';
            }
            this.msgDsplyService.errorToast({
              errors: [
                {
                  message: exe?.errorMessage,
                },
              ],
            });
          }
        );
      } else {
        if (!dialogMessage) {
          this.msgDsplyService.errorToast({
            errors: [
              {
                message: 'Please add atleast one row in ' + labelName,
              },
            ],
          });
        }
      }
    } else {
      this.appGenFormGroup.markAllAsTouched();

      this.msgDsplyService.errorToast({
        errors: [
          {
            message: 'Please Enter Mandatory controls',
          },
        ],
      });
    }
  }

  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//
  //-----------------------------------------------------------------------------------------//

  getId = (data: InputDataModel): string | number =>
    data?.[this.inputDataPropConfig?.idProp];

  getName = (data: InputDataModel): string =>
    data?.[this.inputDataPropConfig?.nameProp];

  getType = (data: InputDataModel): string | number =>
    data?.[this.inputDataPropConfig?.typeProp];

  getOptions = (data: InputDataModel): ComboModel[] =>
    data?.[this.inputDataPropConfig?.comboProp];

  getFormControlValue = (data: InputDataModel): unknown =>
    this.appGenFormGroup?.controls[this.getId(data)]?.value;
}
